/* eslint-disable sort-exports/sort-exports */
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { OrderCustomerNotesProps } from './types';
import { HeaderSx } from '../../styles';
import { ExpandableText } from 'components/ExpandableText';
import { CustomerNotesContainerSx } from './styles';

const OrderCustomerNotes = (props: OrderCustomerNotesProps) => {
  if (!props.order) return null;

  const hasCustomerNotes = !!props.order.checkoutNotes;
  const readOnlyCustomerNotes = hasCustomerNotes
    ? props.order.checkoutNotes
    : '';

  return (
    <Container sx={CustomerNotesContainerSx}>
      <Typography variant="subtitle2" sx={HeaderSx}>
        Customer note
      </Typography>
      {readOnlyCustomerNotes ? (
        <ExpandableText text={readOnlyCustomerNotes} />
      ) : (
        <Typography variant="body2" color="colors.gray60">
          --
        </Typography>
      )}
    </Container>
  );
};

export default OrderCustomerNotes;
